module.exports = __webpack_public_path__ + "008.aa2af016.png";